import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SolutionSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-405">
      <div className="container mx-auto max-w-3xl" data-id="element-406">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-407">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight text-white text-center" data-id="element-408">
            La verdad incómoda sobre la formación en Reiki
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-409">
            <p className="text-white font-bold text-xl md:text-2xl text-center" data-id="element-410">
              La mayoría de los cursos te dan el certificado pero no la
              práctica.
            </p>

            <p className="text-center" data-id="element-411">
              Un fin de semana intensivo. Mucha emoción. Una sintonización. Un
              papel.
            </p>

            <p className="text-center" data-id="element-412">
              Y después vos sola/o frente a tu primera sesión real — sin saber
              qué hacer si algo no sale como en la teoría.
            </p>

            <div className="my-10 p-6 md:p-8 bg-[#111111] border-l-4 border-[#eab308] rounded-r-2xl shadow-lg" data-id="element-413">
              <p className="text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-414">
                Hay un vacío enorme entre tener el certificado y saber practicar
                con confianza real.
              </p>
            </div>

            <p data-id="element-415">
              Ese vacío se llena con práctica guiada, protocolos claros,
              respuestas a las dudas reales y una estructura que te acompañe más
              allá del primer día.
            </p>

            <p data-id="element-416">
              Eso es exactamente lo que construimos durante años en Academia
              Holística Argentina.
            </p>

            <p className="text-[#f0c040] font-bold text-xl md:text-2xl text-center mt-8" data-id="element-417">
              Y hoy lo estamos poniendo todo junto — en un sistema que podés
              empezar ahora mismo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}